'use client';

import { useTranslations } from 'next-intl';
import { Button, ButtonSize, ButtonType } from '@nx-frontend/shared/ui/button';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';

interface TranscriptErrorProps {
  onRetry: () => void;
  isLimitError: boolean;
}

export function TranscriptError({ onRetry, isLimitError }: TranscriptErrorProps) {
  const t = useTranslations('features');

  return (
    <div className="flex flex-col justify-center items-center text-[13px] max-w-[257px] text-center">
      <Icon icon={IconsMap.TRANSCRIPT_ERROR} className="w-[57px] h-[64px]" />
      <div className="font-bold mt-[24px] mb-[8px]">{`Transcript ${!isLimitError ? 'working' : ''} error`}</div>
      {!isLimitError ? (
        <div>{t('transcript.an_error_occured_while_processing')}</div>
      ) : (
        <div>{t('transcript.remaining_limit_does_not_allow')}</div>
      )}
      <div>
        <Button
          onClick={onRetry}
          type={ButtonType.FLAT}
          size={ButtonSize.CUSTOM}
          className="mt-[24px] text-[13px] font-semibold w-[82px] h-[32px]"
        >
          <Icon icon={IconsMap.REPEAT} className="w-[20px] h-[20px] mr-[4px]" />
          {t('transcript.retry')}
        </Button>
      </div>
    </div>
  );
}
